import { render, staticRenderFns } from "./PluginMeta.vue?vue&type=template&id=17ff9336&"
import script from "./PluginMeta.vue?vue&type=script&lang=js&"
export * from "./PluginMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports